<template>
  <div 
    class="service-card" 
    :style="{ background: gradientStyle }"
  >
    <div class="service-card__content">
      <h3 class="service-card__title">{{ title }}</h3>
      <p class="service-card__description" v-if="description">{{ description }}</p>
      <ButtonCTA v-if="withCta" class="service-card__cta" :to="to">
        {{ ctaText || 'En savoir plus' }}
      </ButtonCTA>
    </div>
  </div>
</template>

<script>
import ButtonCTA from './ButtonCTA.vue'

export default {
  name: 'ServiceCard',
  components: {
    ButtonCTA
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'service-gradient-1'
    },
    withCta: {
      type: Boolean,
      default: false
    },
    to: {
      type: String,
      default: '/saas'
    },
    ctaText: {
      type: String,
      default: ''
    }
  },
  computed: {
    gradientStyle() {
      const gradients = {
        'service-gradient-1': 'linear-gradient(to bottom right, #7400b8, #6930c3)',
        'service-gradient-2': 'linear-gradient(to bottom right, #5390d9, #4ea8de)',
        'service-gradient-3': 'linear-gradient(to bottom right, #ff006e, #ff5d8f)',
        'service-gradient-4': 'linear-gradient(to bottom right, #ffbe0b, #ffd166)',
        'service-gradient-5': 'linear-gradient(to bottom right, #2E8B57, #3CB371)'
      }
      
      return gradients[this.color] || gradients['service-gradient-1']
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.service-card {
  border-radius: $border-radius-lg;
  color: $white;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: $spacing-md;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
  
  &__content {
    text-align: center;
  }
  
  &__title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: $spacing-xs;
  }
  
  &__description {
    font-size: 14px;
    opacity: 0.9;
    margin-bottom: $spacing-md;
  }
  
  &__cta {
    margin-top: $spacing-md;
  }
}
</style>